function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M127.836 58.4976H100.545V91.7995H127.836V58.4976Z",
  fill: "#FF6347"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M118.859 106.479H67.8679V140.657H118.859V106.479Z",
  fill: "#FF6347"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M63.5588 51.4866H40.5771V92.2377H63.5588V51.4866Z",
  fill: "#FF6347"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M121.008 47.6036C119.987 52.208 116.491 55.0595 116.491 55.0595C116.491 55.0595 114.65 50.446 115.671 45.8417C116.691 41.2374 120.187 38.3858 120.187 38.3858C120.187 38.3858 122.029 42.9993 121.008 47.6036Z",
  fill: "#FF6347"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M111.722 47.6036C112.743 52.208 116.239 55.0595 116.239 55.0595C116.239 55.0595 118.081 50.446 117.06 45.8417C116.039 41.2374 112.543 38.3858 112.543 38.3858C112.543 38.3858 110.702 42.9993 111.722 47.6036Z",
  fill: "#FF6347"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M113.222 46.6141C116.023 49.9412 116.365 55.0558 116.365 55.0558C116.365 55.0558 112.166 54.776 109.365 51.4489C106.565 48.1218 106.222 43.0073 106.222 43.0073C106.222 43.0073 110.421 43.287 113.222 46.6141Z",
  fill: "#3F3D56"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M119.508 46.6141C116.707 49.9412 116.365 55.0558 116.365 55.0558C116.365 55.0558 120.564 54.776 123.365 51.4489C126.166 48.1218 126.508 43.0073 126.508 43.0073C126.508 43.0073 122.309 43.287 119.508 46.6141Z",
  fill: "#3F3D56"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.1389 35.8567C37.0468 35.959 40.1555 39.4148 40.1555 39.4148C40.1555 39.4148 36.9282 42.7048 33.0203 42.6025C29.1124 42.5002 26.0037 39.0444 26.0037 39.0444C26.0037 39.0444 29.231 35.7544 33.1389 35.8567Z",
  fill: "#FF6347"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.4918 19.5787C17.0225 21.6255 21.071 20.2375 21.071 20.2375C21.071 20.2375 19.3952 15.531 15.8646 13.4842C12.3339 11.4374 8.2854 12.8254 8.2854 12.8254C8.2854 12.8254 9.96119 17.5319 13.4918 19.5787Z",
  fill: "#FF6347"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.8505 17.5446C17.7431 17.1105 21.1503 20.1183 21.1503 20.1183C21.1503 20.1183 18.2464 23.8298 14.3538 24.2639C10.4612 24.698 7.05396 21.6903 7.05396 21.6903C7.05396 21.6903 9.95792 17.9787 13.8505 17.5446Z",
  fill: "#3F3D56"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.1197 18.367C27.7466 23.1151 30.1962 27.2861 30.1962 27.2861C30.1962 27.2861 33.2507 23.7591 33.6238 19.0111C33.9969 14.263 31.5473 10.092 31.5473 10.092C31.5473 10.092 28.4928 13.619 28.1197 18.367Z",
  fill: "#3F3D56"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M46.4518 47.4866C44.4101 51.554 45.1126 56.6134 45.1126 56.6134C45.1126 56.6134 49.1252 55.0783 51.1669 51.0108C53.2086 46.9434 52.5062 41.884 52.5062 41.884C52.5062 41.884 48.4935 43.4191 46.4518 47.4866Z",
  fill: "#3F3D56"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.5288 91.71L40.8263 91.4646C39.7775 89.6074 39.2049 87.4116 39.1811 85.1564C39.1895 81.8574 40.5174 78.806 41.8016 75.8551C42.04 75.3074 42.2776 74.7614 42.5061 74.2158C43.4655 71.9909 44.23 69.6488 44.7871 67.2284C46.7791 58.1952 44.8179 47.5378 39.5409 38.7197C35.3548 31.7244 29.1145 25.6073 20.4636 20.019L20.2957 20.4062C28.8972 25.9627 35.0976 32.0377 39.2509 38.9781C44.4644 47.69 46.4043 58.2084 44.4403 67.1146C43.8897 69.5054 43.1343 71.8187 42.1865 74.0164C41.9586 74.5599 41.7219 75.1038 41.4844 75.6496C40.1798 78.6476 38.8306 81.7476 38.822 85.1551C38.8458 87.4982 39.4399 89.7798 40.5288 91.71Z",
  fill: "#3F3D56"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.41135 20.5947C5.29538 20.5947 6.82269 18.731 6.82269 16.432C6.82269 14.133 5.29538 12.2692 3.41135 12.2692C1.52731 12.2692 0 14.133 0 16.432C0 18.731 1.52731 20.5947 3.41135 20.5947Z",
  fill: "#3F3D56"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M66.7905 88.5132H43.4497V47.3239H66.7905V88.5132ZM43.8088 88.075H66.4314V47.7621H43.8088V88.075Z",
  fill: "#3F3D56"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61.0452 58.2785H46.3225V58.7167H61.0452V58.2785Z",
  fill: "white"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.9775 63.0853H46.2549V63.5235H60.9775V63.0853Z",
  fill: "white"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.9097 67.8922H46.187V68.3304H60.9097V67.8922Z",
  fill: "white"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.842 72.699H46.1194V73.1372H60.842V72.699Z",
  fill: "white"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.7744 77.5059H46.0518V77.9441H60.7744V77.5059Z",
  fill: "white"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.7068 82.3127H45.9841V82.7509H60.7068V82.3127Z",
  fill: "white"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M114.729 110.861H76.3064V111.299H114.729V110.861Z",
  fill: "white"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M114.661 115.886H76.2388V116.325H114.661V115.886Z",
  fill: "white"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M114.594 120.912H76.1711V121.351H114.594V120.912Z",
  fill: "white"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M114.526 125.938H76.1033V126.377H114.526V125.938Z",
  fill: "white"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M114.458 130.964H76.0356V131.403H114.458V130.964Z",
  fill: "white"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M124.783 63.3176H106.829V63.7557H124.783V63.3176Z",
  fill: "white"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M124.716 68.1245H106.761V68.5626H124.716V68.1245Z",
  fill: "white"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M124.648 72.9313H106.694V73.3695H124.648V72.9313Z",
  fill: "white"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M124.58 77.7382H106.626V78.1763H124.58V77.7382Z",
  fill: "white"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M124.513 82.545H106.558V82.9832H124.513V82.545Z",
  fill: "white"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M122.988 136.933H71.6384V102.316H122.988V136.933ZM71.9975 136.494H122.629V102.754H71.9975V136.494Z",
  fill: "#3F3D56"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M97.2897 102.809L97.1899 102.695L66.4878 67.3997L66.7341 67.0807L97.3364 102.261L116.329 88.107L116.516 88.4812L97.2897 102.809Z",
  fill: "#3F3D56"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M131.247 88.5132H103.597V54.773H131.247V88.5132ZM103.956 88.075H130.888V55.2112H103.956V88.075Z",
  fill: "#3F3D56"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M171.411 14.5776C168.062 7.67183 161.436 7.34999 161.436 7.34999C161.436 7.34999 154.979 6.34242 150.837 16.8599C146.976 26.6631 141.648 36.1283 149.979 38.4231L151.484 32.7077L152.416 38.8487C153.602 38.9528 154.792 38.9776 155.981 38.923C164.903 38.5715 173.399 39.0258 173.126 35.119C172.762 29.9255 174.634 21.2223 171.411 14.5776Z",
  fill: "#2F2E41"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M174.672 95.2622C174.672 95.2622 170.47 104.322 173.692 105.006C176.914 105.689 179.015 97.1425 179.015 97.1425L174.672 95.2622Z",
  fill: "#A0616A"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M182.937 52.6994C182.377 59.8786 181.536 97.8262 179.155 99.0228C176.774 100.219 172.851 100.219 172.851 100.219V66.716C172.851 66.716 173.832 43.2979 177.334 40.563H179.359C179.595 40.5628 179.827 40.6298 180.037 40.7586C180.248 40.8874 180.431 41.0745 180.571 41.3048C180.589 41.3339 180.606 41.3646 180.623 41.3954C181.534 43.0945 183.362 47.2585 182.937 52.6994Z",
  fill: "#D0CDE1"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M146.586 106.8L147.147 125.432C147.147 125.432 145.325 143.722 146.866 149.363L151.349 150.218C151.349 150.218 156.392 131.928 155.691 125.432L158.633 106.8L151.209 95.3477L146.586 106.8Z",
  fill: "#A0616A"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M163.676 100.305L164.376 109.364L167.318 129.706C167.318 129.706 168.999 142.184 172.501 150.218L174.742 158.936L178.525 157.226C178.525 157.226 179.645 139.278 175.163 125.261L174.462 107.997L169.699 98.2535L163.676 100.305Z",
  fill: "#A0616A"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M171.661 71.0749L152.47 66.6306C152.47 66.6306 146.866 77.3995 145.045 107.484L149.388 108.852L150.649 100.818L151.489 109.364L166.338 111.074L167.738 102.185L168.719 111.587L176.283 110.048C176.283 110.048 175.583 77.9123 171.661 71.0749Z",
  fill: "#2F2E41"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M152.4 148.765H145.816L145.115 153.893C145.115 153.893 136.711 168.935 143.014 168.081C149.318 167.226 149.458 163.124 149.458 163.124C149.458 163.124 152.119 160.047 152.4 158.508C152.68 156.97 151.699 153.209 151.699 153.209L152.4 148.765Z",
  fill: "#2F2E41"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M179.015 154.064L172.851 155.602V166.713C172.851 166.713 171.03 177.653 176.213 176.969C181.396 176.285 180.556 167.055 180.556 167.055L179.015 154.064Z",
  fill: "#2F2E41"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M159.964 32.6999C164.064 32.6999 167.388 28.6438 167.388 23.6404C167.388 18.6369 164.064 14.5808 159.964 14.5808C155.864 14.5808 152.54 18.6369 152.54 23.6404C152.54 28.6438 155.864 32.6999 159.964 32.6999Z",
  fill: "#A0616A"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M158.563 31.1615C158.563 31.1615 160.804 37.1442 160.244 38.1699C159.684 39.1955 171.45 37.4861 171.45 37.4861C171.45 37.4861 166.127 27.7428 166.127 25.6916L158.563 31.1615Z",
  fill: "#A0616A"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M140.773 86.8864C140.773 86.8864 136.571 95.946 139.792 96.6297C143.014 97.3135 145.115 88.7667 145.115 88.7667L140.773 86.8864Z",
  fill: "#A0616A"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.15,
  d: "M175.093 58.853C175.093 58.853 176.353 66.887 174.812 71.3313C174.353 72.656 173.657 73.0235 172.851 72.9039V66.716C172.851 66.716 173.832 43.2979 177.334 40.563H179.359C179.595 40.5628 179.827 40.6298 180.037 40.7586C180.248 40.8874 180.431 41.0745 180.571 41.3048L175.093 58.853Z",
  fill: "black"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M170.399 33.8557C168.566 34.3349 162.104 35.9649 159.628 35.7983C159.476 35.7874 159.323 35.8223 159.185 35.9L157.582 36.8024L150.261 41.0342C150.072 41.1433 149.919 41.3271 149.827 41.5556C149.734 41.7842 149.708 42.0441 149.752 42.2934L152.386 57.2965C152.429 57.5404 152.405 57.7948 152.317 58.02C152.229 58.2452 152.083 58.4286 151.9 58.5414C149.76 59.8608 143.442 64.4136 151.979 67.7416C162.065 71.6731 164.306 70.8185 166.407 70.1347C168.509 69.451 172.711 75.7756 174.252 71.3313C175.616 67.3958 174.784 60.6455 174.576 59.1515C174.548 58.9529 174.564 58.7488 174.623 58.5607L179.839 41.8536C179.921 41.5929 179.92 41.3048 179.838 41.0445C179.756 40.7842 179.598 40.5702 179.394 40.4434L173.402 36.7127C173.315 36.6589 173.236 36.5888 173.168 36.505L171.248 34.1621C171.139 34.0286 171.004 33.9306 170.855 33.8771C170.707 33.8235 170.55 33.8162 170.399 33.8557Z",
  fill: "#D0CDE1"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M151.419 41.2467H150.3C150.103 41.2467 149.911 41.3308 149.759 41.4845C149.607 41.6382 149.504 41.8519 149.467 42.0887L145.816 65.5195L142.174 80.2199C142.174 80.2199 133.349 85.5189 139.932 88.4248C146.516 91.3307 149.878 90.3051 149.178 87.0573C148.477 83.8096 155.201 62.6136 155.201 62.6136L151.419 41.2467Z",
  fill: "#D0CDE1"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M162.247 13.2314C164.893 13.2314 167.038 10.6139 167.038 7.38499C167.038 4.15609 164.893 1.53854 162.247 1.53854C159.601 1.53854 157.456 4.15609 157.456 7.38499C157.456 10.6139 159.601 13.2314 162.247 13.2314Z",
  fill: "#2F2E41"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  d: "M156.951 5.84644C156.951 4.4025 157.389 3.00969 158.181 1.93631C158.972 0.862925 160.061 0.184908 161.238 0.0328644C161.071 0.0112061 160.902 0.000237044 160.734 1.09556e-06C160.104 -0.000469087 159.481 0.150406 158.899 0.444007C158.318 0.737608 157.789 1.16818 157.344 1.71112C156.899 2.25406 156.546 2.89872 156.305 3.60828C156.064 4.31784 155.94 5.07838 155.94 5.84645C155.94 6.61451 156.064 7.37505 156.305 8.08461C156.546 8.79417 156.899 9.43883 157.344 9.98177C157.789 10.5247 158.318 10.9553 158.899 11.2489C159.481 11.5425 160.104 11.6934 160.734 11.6929C160.902 11.6927 161.071 11.6817 161.238 11.66C160.061 11.508 158.972 10.83 158.181 9.75658C157.389 8.6832 156.951 7.29039 156.951 5.84644Z",
  fill: "#2F2E41"
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M169.931 13.9119L163.384 9.72748L154.344 11.4392L152.474 21.5199L157.13 21.3012L158.43 17.5979V21.2403L160.579 21.1393L161.826 15.2433L162.605 21.5199L170.242 21.3297L169.931 13.9119Z",
  fill: "#2F2E41"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M167.318 24.2814C167.86 24.2814 168.299 23.3439 168.299 22.1874C168.299 21.031 167.86 20.0935 167.318 20.0935C166.777 20.0935 166.338 21.031 166.338 22.1874C166.338 23.3439 166.777 24.2814 167.318 24.2814Z",
  fill: "#A0616A"
});

var SvgAbout = function SvgAbout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 183,
    height: 177,
    viewBox: "0 0 183 177",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAbout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/about.c063136e.svg";
export { ForwardRef as ReactComponent };